import { render, staticRenderFns } from "./ImportProductModal.vue?vue&type=template&id=87e65f72&scoped=true"
import script from "./ImportProductModal.vue?vue&type=script&lang=ts"
export * from "./ImportProductModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e65f72",
  null
  
)

export default component.exports